import api from "api/api";

const buildQueryParams = (params) => new URLSearchParams(params).toString();

export const getAvailableDocumentsQuery = async ({
  userScope,
  entityId,
  BASE_URL,
}) => await api.get(`${BASE_URL}/${entityId}?scope=${userScope}`);

export const getDocumentBlob = async ({ type, queryParams, BASE_URL }) => {
  const query = buildQueryParams(queryParams);

  return await api.getBlob(`${BASE_URL}/${type}?${query}`);
};

export const getSixYearReviewBlob = async ({ file_id }) =>
  await api.getBlob(`/file/${file_id}`);
